import { call, put, takeLatest } from 'redux-saga/effects';
import * as url from '../../helpers/url_helper';
import { pickupOrdersTypes } from './actionTypes';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';
import { getMilestoneConfigPKFail, getMilestoneConfigPKSuccess, getPickupOrdersFail, getPickupOrdersSuccess } from './actions';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchPK = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

export const fetchPickupOrders = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetPickupOrders(PickupOrders: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF ?? ''}
      ${dynamicFilter ?? ''}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        CountItems
        pickupOrdersData {
            id
            initial_date
            final_date
            order
            Number
            clientId
            GUID
            CreatedOn
            AreaPrecision
            BondedEntryDate
            BondedWarehouseNumber
            BondedWarehouseType
            CarrierBookingNumber
            CarrierName
            CarrierPRONumber
            CarrierTrackingNumber
            ConsigneeName
            CreatedBy
            CreatorNetworkID
            DbClassType
            DeliveryDate
            DeliveryEntityName
            DestinationAgentName
            DocumentTemplateName
            DriverLicenseNumber
            DriverName
            IsOnlineTransaction
            IsTrackingEmailSent
            IssuedByName
            LastItemID
            LengthPrecision
            LengthUnit
            ModeOfTransportCode
            Notes
            PickupDate
            PickupEntityName
            ShipperName
            Status
            SupplierInvoiceNumber
            SupplierName
            SupplierPONumber
            TotalPieces
            Type
            Version
            VolumePrecision
            VolumeUnit
            VolumeWeightPrecision
            WeightPrecision
            WeightUnit
            VolumeWeightUnit
          customFields {
            id
            value
            clientId
            OperationNumber
            name
            internalName
            OperationType
            OperationGUID
            createdAt
            updatedAt
          }
        }
      }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());
    return response.data.GetPickupOrders;
};

function* fetchPickupOrdersSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchPickupOrders, data.payload);
        yield put(getPickupOrdersSuccess(response));
    } catch (error) {
        yield put(getPickupOrdersFail(error));
    }
}

function* getMilestoneConfigPK(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, "PK");
    yield put(getMilestoneConfigPKSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigPKFail(error));
  }
}


function* PickupOrdersSaga() {
    yield takeLatest(pickupOrdersTypes.GET_PICKUP_ORDERS, fetchPickupOrdersSaga);
    yield takeLatest(pickupOrdersTypes.GET_MILESTONESCONFIG_PK, getMilestoneConfigPK)
}

export default PickupOrdersSaga;
